import React, { useState } from 'react';
import { navigate } from 'gatsby';

import ArrowRight from './svg/ArrowRight';

const NewsletterSignUp = ({ className }) => {
  const [email, setEmail] = useState();
  const [botField, setBotField] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        'form-name': form.getAttribute('name'),
        email,
        'bot-field': botField,
      }),
    }).then(() => {
      console.log('Done');
      navigate('/thank-you-newsletter');
    });
  };

  return (
    <div className={className}>
      <form
        onSubmit={handleSubmit}
        name="newsletter"
        method="POST"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        className="w-full flex flex-col items-start sm:flex-row"
      >
        <div className="hidden">
          <input name="bot-field" value={botField} onChange={(e) => setBotField(e.target.value)} />
        </div>
        <input
          id="email-address"
          name="email"
          type="email"
          autoComplete="email"
          className="block w-full px-4 py-2 text-black placeholder-gray-500 rounded-full focus:outline-none focus:ring-sp-primary-green ring-0 focus:ring-2"
          aria-label="Enter your email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          type="submit"
          className="inline-flex btn btn-sp-pastel-dark-bg sm:ml-4 mt-6 sm:mt-0 w-full sm:w-auto justify-center"
        >
          <span>Sign up</span> <ArrowRight className="ml-5 mb-[3px]" />
        </button>
      </form>
    </div>
  );
};

export default NewsletterSignUp;
